import { Component } from 'react';
import { validator } from 'Helpers/validator';
import Loginbg from './images/login-wallpaper.svg';
import { NavLink, Link } from 'react-router-dom';
import loginlogo from 'assets/images/logo.svg';
import yabsyslogo from 'assets/images/DAZAPP-Logo.svg';
import yabsystext from 'assets/images/Daz App.svg';
// import Backarrow  from 'assets/images/slider-left-arrow.svg';
import Backarrow  from 'assets/images/svg/Left Arrow.svg';
import labeltop from 'Helpers/labelTop';
import LoadingOverlay from 'react-loading-overlay';
import { ReactComponent as Triangle } from 'assets/images/svg/triangle.svg';
import { ReactComponent as Square } from 'assets/images/svg/square.svg';
import { ReactComponent as Bubble } from 'assets/images/svg/bubble.svg';
import Lottie from 'react-lottie-player';
import lottieJson from 'assets/js/animation.json';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';
import loginbanner from 'assets/images/login-banner.svg';

/**
 * @file
 * User can retreive their password through email
 * @module 3.ForgotPassword
 * @extends Component
 */

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailId: '',
      errorElement: '',
      popup:false
    };
    this.validator = validator.getInstance();
  }
  componentDidUpdate(prevProps) {
    if (this.props.errorElement !== prevProps.errorElement) {
      this.setState({ errorElement: this.props.errorElement });
    }
    if (this.props.popup !== prevProps.popup) {
      this.setState({ popup: this.props.popup });
    }
  }

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */

  validation = e => {
    const superparent = e.target.parentElement;
    !e.target.value && superparent.classList.remove('top');
    if (!e.target.dataset.validation || !e.target.dataset.check) {
      return;
    }
    const inputRules = e.target.dataset.validation.split(',');
    const elementObject = {
      formId: 'forgotpassword',
      elementName: e.target.name,
      elementValue: e.target.value,
      message: e.target.dataset.error
    };
    this.validator.validate(elementObject, inputRules);
  };

  /**
   * @method handleEmailIdChange
   * @summary set the emailId state
   * @param {event} event - React onChange event
   * @return {none} undefined
   */

  handleEmailIdChange = event => {
    this.setState({ emailId: event.target.value });
  };

  /**
   * @method handleValidSubmit
   * @summary validate the emailId based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */

  handleValidSubmit = event => {
    event.preventDefault();
    const formId = event.target.id;
    this.setState({ errorElement: null }, () => {
      if (formId && !this.validator.checkBeforeSubmit(formId)) {
        this.props.forgotPassword(this.state.emailId);
      }
    });
  };

  render() {
    const { errorElement,popup } = this.state;
    const { loading } = this.props;
    return (
      <>
      <div className='main-logindiv' id='login-page'>
        <LoadingOverlay
          active={ loading }
          spinner
          styles={ {
            wrapper: {
              width: '100%',
              textAlign: '-webkit-center'
            }
          } }
          text='Please wait...'
        ></LoadingOverlay>
        <div className="loginPage">
          <div className="loginPage__left">
            {/* <Lottie
                loop={ true }
                animationData={ lottieJson }
                play={ true }
                speed={ 1 }
                className="lottie"
              /> */}
          <img src={ loginbanner } alt="login-banner" width="470"/>
          </div>

          <div className="loginPage__right">
            <div className="loginPage__right--form">
              <div className='logo-container'>
                <img className="logo" src={ yabsyslogo } alt="Logo" width="80" />
                <img className="logo" src={ yabsystext } alt="Logo" width="90" />
              </div>     
              <svg width="0" height="0" className="hidden">
                <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.495 14.253" id="icon-visibility-off">
                  <path id="Icon_material-visibility-off" d="M9.751,7.5A3.752,3.752,0,0,1,13.5,11.251a3.641,3.641,0,0,1-.27,1.373l2.19,2.19A8.865,8.865,0,0,0,18,11.251,8.872,8.872,0,0,0,9.744,5.625a8.735,8.735,0,0,0-2.986.525l1.62,1.62A3.641,3.641,0,0,1,9.751,7.5ZM2.25,5.453l1.71,1.71.345.345A8.855,8.855,0,0,0,1.5,11.251a8.868,8.868,0,0,0,11.537,5l.315.315,2.2,2.19L16.5,17.8,3.2,4.5ZM6.4,9.6l1.163,1.163a2.116,2.116,0,0,0-.06.488,2.247,2.247,0,0,0,2.25,2.25,2.116,2.116,0,0,0,.488-.06L11.4,14.6a3.726,3.726,0,0,1-5-5Zm3.233-.585,2.363,2.363.015-.12a2.247,2.247,0,0,0-2.25-2.25Z" transform="translate(-1.5 -4.5)"></path>
                </symbol>
                <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.494 10.996" id="icon-visibility-on">
                  <path id="Icon_awesome-eye" d="M16.395,9.58A9.185,9.185,0,0,0,8.247,4.5,9.186,9.186,0,0,0,.1,9.58a.926.926,0,0,0,0,.836A9.185,9.185,0,0,0,8.247,15.5a9.186,9.186,0,0,0,8.147-5.08A.926.926,0,0,0,16.395,9.58ZM8.247,14.122A4.124,4.124,0,1,1,12.371,10,4.124,4.124,0,0,1,8.247,14.122Zm0-6.873a2.729,2.729,0,0,0-.725.109A1.37,1.37,0,0,1,5.607,9.273,2.743,2.743,0,1,0,8.247,7.249Z" transform="translate(0 -4.5)"></path>
                </symbol>
              </svg>
              <form
              id='forgotpassword'
              noValidate={ true }
              onSubmit={ this.handleValidSubmit }>
                <div className="form-group">
                  <label className="login-label"> E-Mail Address </label>
                  <input
                        id='userEmailId'
                        name='emailId'
                        onBlur={ this.validation }
                        data-validation={ [ 'email' ] }
                        onChange={ this.handleEmailIdChange }
                        onFocus={ labeltop }
                        type='email'
                        value={ this.state.emailId }
                        className='form-control input-lg'
                      />
                </div>
                <button type='submit' className='btn btn_primary submitBtn mt-20'>Submit</button>
                  <Link to='/login' className="login-link back-to-login">
                    <img src={ Backarrow } alt="Back Arrow"></img> Back to login
                  </Link>
              </form>
              { popup &&
                  <div className='seccess-popup'>
                    <div className='content-wraper'>
                      <i className='popup_close' onClick={ () => this.setState({ popup:false }) }><Close/></i>
                      <p>
                        A reset password link has been sent to your email, click the link
                        to reset password
                      </p>
                      <div className='action'>
                        <Link to='/login' className='btn btn_primary'>ok</Link>
                      </div>
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
      {/* <div className='main-logindiv' style={ { display:'none' } }>
        <LoadingOverlay
          active={ loading }
          spinner
          styles={ {
            wrapper: {
              width: '100%',
              textAlign: '-webkit-center'
            }
          } }
          text='Please wait...'
        >
          <div className='icons'>
            <div className='right-side'>
              <Triangle className='triangle' />
              <Square className='square' />
            </div>
            <div className='left-side'>
              <Triangle className='triangle' />
              <Square className='square' />
            </div>
          </div>
          <div className='login'>
            <div className='left-section'>
              <img src={ Loginbg } name='bg-image' />
            </div>
            <div className='right-section'>
              <Bubble className='bubble' />

              <section>
                <div className='login-logo'>
                  <img src={ loginlogo } name='logo' />
                </div>
                <div className='main-login forgotpassword'>
                  <form
                    id='forgotpassword'
                    noValidate={ true }
                    onSubmit={ this.handleValidSubmit }
                  >
                    <h2>Forgot password</h2>
                    <div className='form-group'>
                      <label>Email</label>
                      <input
                        id='userEmailId'
                        name='emailId'
                        onBlur={ this.validation }
                        data-validation={ [ 'email' ] }
                        onChange={ this.handleEmailIdChange }
                        onFocus={ labeltop }
                        type='email'
                        value={ this.state.emailId }
                      />
                       {errorElement !== '' && (
                      <span className='errorElement'>{errorElement}</span>
                    )}
                    </div>
                   
                    <button
                      type='submit'
                      className='btn btn_primary'
                      disabled={ loading }
                    >
                      <span>Submit</span>
                    </button>
                    <Link to='/login'>
                      Back to login
                    </Link>
                  </form>
                  { popup &&
                    <div className='seccess-popup'>
                    <div className='content-wraper'>
                      <i className='popup_close'><Close/></i>
                      <p>
                        A reset password link has been sent to your email, click the link
                        to reset password
                      </p>
                      <div className='action'>
                        <Link to='/login' className='btn btn_primary'>ok</Link>
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </section>
            </div>
          </div>
        </LoadingOverlay>
      </div> */}
      </>
    );
  }
}
